import {InjectionToken} from '@angular/core';

export interface RtTitlesConfig {
  titleDefault: string;
  titleSeparator: string;
}

export const defaultRtTitlesConfig: RtTitlesConfig = {
  titleDefault: 'RT Admin',
  titleSeparator: ' - ',
};

export const RtTitlesConfigToken = new InjectionToken<RtTitlesConfig>('RtTitlesConfigToken');
